import { call, delay, takeEvery } from 'redux-saga/effects';
import { GlobalPut } from '@ps20-frontend/shop-integration-redux';
import { NotificationModel } from '@ps20-frontend/gui-components';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { App } from '@ps20-frontend/frontend-models';
import { DashboardAction, DashboardActions } from '../dashboard.actions';

export function* notificationSaga() {
  yield takeEvery(
    DashboardActions.ADD_NOTIFICATION,
    safeSaga(deleteNotificationAfterTimeout, App.SHOP_DASHBOARD),
  );
}

export function* deleteNotificationAfterTimeout(action: DashboardAction<NotificationModel>) {
  const globalPut = GlobalPut.getInstance();

  yield delay(action.payload.millisecondsToLive);
  yield call(globalPut.put, new DashboardActions().deleteNotification(action.payload.id));
}
